import { DEFAULT_OBJECTIVE_SUFFIX, OBJECTIVE_SUFFIX_BY_CAMPAIGN_TYPE } from '../../campaign/constants/CampaignConstants'
import { hasValue } from '../NumberUtil'
import useSandreList from './useSandreList'

const useCampaignObjectives = (campaignType) => {
    const suffix = hasValue(campaignType) ? OBJECTIVE_SUFFIX_BY_CAMPAIGN_TYPE[campaignType] ?? DEFAULT_OBJECTIVE_SUFFIX : undefined
    return useSandreList(suffix && `CAUSE_INTERVENTION.${suffix}`)
}

export default useCampaignObjectives
